import { ShapeOptions } from '@mui/system/createTheme/shape';

const shapes: ShapeOptions = {
  borderRadius: 4,
};

export default shapes;
